import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { ServiceMetadataWithConnection } from "../types";
export function useTaskServices() {
  const $ = _c(2);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = {
      queryKey: QUERY_KEYS.TASK_SERVICES,
      queryFn: async () => {
        const data = await apiFetcher("/api/v1/tasks/external/services/metadata/with-connection");
        return Array.isArray(data?.data) ? data.data : [];
      },
      staleTime: 0,
      gcTime: 300000,
      refetchOnMount: true
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}
export function useTaskService(source) {
  const $ = _c(10);
  const t0 = useTaskServices();
  let rest;
  let services;
  if ($[0] !== t0) {
    ({
      data: services,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = rest;
    $[2] = services;
  } else {
    rest = $[1];
    services = $[2];
  }
  let t1;
  if ($[3] !== services || $[4] !== source) {
    t1 = services?.find(s => s.source === source);
    $[3] = services;
    $[4] = source;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const service = t1;
  const t2 = service?.isConnected ?? false;
  let t3;
  if ($[6] !== rest || $[7] !== service || $[8] !== t2) {
    t3 = {
      ...rest,
      data: service,
      isConnected: t2
    };
    $[6] = rest;
    $[7] = service;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}